export class IndexKv {
  constructor() {
    this.loading = document.getElementById('js-loading')
    this.fixedKv = document.getElementById('js-index-fixed-kv')
  }

  initLoading() {
    // `this.loading` が存在する場合のみ処理を実行
    if (this.loading) {
      const video = this.loading.querySelector('video')
      if (video) {
        video.play()
      }
    }
  }

  initKv(currentTime = 0) {
    console.log(currentTime)

    // `this.fixedKv` が存在する場合のみ処理を実行
    if (this.fixedKv) {
      const video = this.fixedKv.querySelector('video')
      if (video) {
        video.currentTime = currentTime
        video.play()

        video.addEventListener('ended', () => {
          video.currentTime = 3
          video.play()
        })
      }
    }
  }
}
